<div class="assign-number-modal-container">
  <div *ngIf="!isLoaded; else addNumberContainer">
    <app-loader></app-loader>
  </div>
  <ng-template #addNumberContainer>
    <div *ngIf="!isEditModal" class="choose-channel-container">
      <h4>{{ 'view_translations.choose_channel_ivr_number' | translate }}</h4>

      <div [ngClass]="{'disabled-switch': Object.keys(fieldsWithValues).length === 1}" class="switch-button">
        <div
          [ngStyle]="{
            'left': ( isEsotericChannel || Object.keys(fieldsWithValues).length === 1 ) ? '7px' : '50%'
          }"
          class="switch-moving-part switch-box-shadow"></div>
        <div
          (click)="changeActiveChannel(option)"
          *ngFor="let option of Object.keys(fieldsWithValues), index as i"
          [ngClass]="{
            'active-item' :  currentActiveSwitch === option,
            'left-option': i === 0,
            'right-option': i === 1
          }">
          <h5>{{ 'view_translations.' + fieldsWithValues[option].text | translate }}</h5>
        </div>
      </div>
    </div>
    <div *ngIf="!isEditModal" class="rate-container container-with-border">
      <h4>{{ 'view_translations.ivr_charge' | translate }}</h4>

      <div [ngClass]="{'disabled-switch': isEsotericChannel}" class="switch-button">
        <div
          [ngStyle]="{ 'left': currentActiveRate === rate1 || fieldsWithValues[currentActiveSwitch].values.length === 1 ? '7px' : '50%' }"
          class="switch-moving-part switch-box-shadow"></div>
        <div
          (click)="currentActiveRate = value"
          *ngFor="let value of fieldsWithValues[currentActiveSwitch].values, index as i"
          [ngClass]="{
              'active-item' :  currentActiveRate === value,
              'left-option': i === 0,
              'right-option': i === 1
            }"
          class="left-option">
          <h5>{{ '+' + divideNumber(value) + ' ' + currency }}</h5>
        </div>
      </div>
    </div>
    <form [formGroup]="form">
      <div
        [ngClass]="{
          'input-invalid': submitted && formControls.name.invalid,
          'focused-input-default': isFocused
        }"
        class="name-container container-with-border">
        <h4>{{ 'view_translations.ivr_name' | translate }}</h4>
        <input
          (blur)="isInputBlur()"
          (focus)="isFocused = true"
          (input)="getValue()"
          formControlName="name"
          placeholder="{{ 'view_translations.type_text' | translate }}"
          type="text" />
        <div *ngIf="submitted && formControls.name.invalid" class="error-icon">
          <nb-icon icon="cross-circle" pack="icomoon"></nb-icon>
        </div>
      </div>
    </form>
    <div *ngIf="submitted && formControls.name.invalid" class="error-text">
      <small *ngIf="submitted && formControls.name.errors?.required" class="form-text text-danger"
        >{{ 'view_translations.this_field_is_required' | translate }}</small
      >
    </div>
    <div *ngIf="showEditButton || !isEditModal" class="add-configuration-button-container">
      <button (click)="verify()" class="add-configuration-button">
        <span>
          <nb-icon *ngIf="!configurationData" class="plus-icon" icon="plus" pack="icomoon"></nb-icon>
          {{ (configurationData ? 'view_translations.edit_configuration_modal' : 'view_translations.add_number') | translate }}
        </span>
      </button>
    </div>
  </ng-template>
</div>
